import { Field } from "../dynamic/DynamicForm";
import { FieldValues } from "react-hook-form";
import DynamicFilter from "./DynamicFilter";
import { useTranslation } from "react-i18next";
import IconButton from "components/button/IconButton";

type MobileFilterType = {
  open: boolean;
  onClose: () => void;
  onSubmit: (filterData: FieldValues) => void;
  fields: Field[];
  loading: boolean;
  values?: boolean;
};

const MobileFilterDrawer = ({
  open,
  onClose,
  onSubmit,
  fields,
  loading,
}: MobileFilterType) => {
  const { t } = useTranslation();

  return (
    <div className="md:hidden">
      <div
        className={`
          bg-black/40 fixed inset-0 z-[99999]
          transition-opacity duration-300
          ${open ? "opacity-100" : "pointer-events-none opacity-0"}
        `}
        onClick={onClose}
      />

      <div
        className={`
          fixed bottom-0 left-0 right-0 z-[999999]
          transform transition-transform duration-300 ease-out
          ${open ? "translate-y-0" : "translate-y-full"}
        `}
      >
        <div
          className="max-h-[70vh] overflow-hidden rounded-t-2xl bg-white p-4 dark:bg-navy-600"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="mb-2 flex items-center justify-between">
            <h2 className="text-md font-bold dark:text-gray-300">
              {t("buttons.filters")}
            </h2>
            <IconButton
              handler={onClose}
              title={t("buttons.filters")}
              icon={
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.04289 16.5413C5.65237 16.9318 5.65237 17.565 6.04289 17.9555C6.43342 18.346 7.06658 18.346 7.45711 17.9555L11.9987 13.4139L16.5408 17.956C16.9313 18.3466 17.5645 18.3466 17.955 17.956C18.3455 17.5655 18.3455 16.9323 17.955 16.5418L13.4129 11.9997L17.955 7.4576C18.3455 7.06707 18.3455 6.43391 17.955 6.04338C17.5645 5.65286 16.9313 5.65286 16.5408 6.04338L11.9987 10.5855L7.45711 6.0439C7.06658 5.65338 6.43342 5.65338 6.04289 6.0439C5.65237 6.43442 5.65237 7.06759 6.04289 7.45811L10.5845 11.9997L6.04289 16.5413Z"
                    fill="currentColor"
                  />
                </svg>
              }
            />
          </div>

          <div className="my-2 border" />

          <DynamicFilter
            onSubmit={onSubmit}
            fields={fields}
            defaultValues={{}}
            loading={loading}
            isMobile={true}
            onClose={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileFilterDrawer;
